import WaveDivider from "./WaveDivider";
import { COLORS, hexToRgba } from "../constants/colors";
import { SECTION_IDS } from "../constants/sections";
import { HERO_STRINGS } from "../constants/strings";

const heroOverlay = [
  hexToRgba(COLORS.red, 0.92),
  hexToRgba(COLORS.red, 0.55),
  hexToRgba(COLORS.red, 0.15),
].join(", ");

function Hero() {
  return (
    <section
      id={SECTION_IDS.home}
      className="hero"
      style={{
        backgroundImage: `linear-gradient(90deg, ${heroOverlay}), url(${process.env.PUBLIC_URL}/hero-steamed-idiyappam.jpeg)`,
      }}
    >
      <div className="hero-content">
        <span className="hero-badge">{HERO_STRINGS.badge}</span>
        <h1>
          {HERO_STRINGS.titleBeforeScript}{" "}
          <span className="script">{HERO_STRINGS.titleScript}</span>{" "}
          {HERO_STRINGS.titleAfterScript}
        </h1>
        <p className="hero-copy">{HERO_STRINGS.copy}</p>
      </div>
      <WaveDivider fill={COLORS.white} className="wave-hero" />
    </section>
  );
}

export default Hero;
